// extracted by mini-css-extract-plugin
export var card = "_mt-0";
export var content = "_mt-2";
export var details = "_mt-3";
export var icon = "_mt-1";
export var iconBlue = "_mt-5";
export var iconBrand = "_mt-4";
export var iconGrayBlue = "_mt-6";
export var iconGreen = "_mt-7";
export var iconIndigo = "_mt-8";
export var iconOrange = "_mt-9";
export var iconPurple = "_mt-a";
export var iconRed = "_mt-b";
export var iconWarning = "_mt-c";